import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'
import './fieldList.css'
import {
    getComponentFromField,
    getLabelComponentFromField,
} from '../../../../helpers/collaborativeIndexations'

class FieldList extends Component {

    static propTypes = {
        t: PropTypes.func.isRequired,
        fields: PropTypes.object.isRequired,
    }

    render()
    {
        const { fields } = this.props

        return (
            <div id={'field-list'}>
                <ul>
                    {
                        fields &&
                        Object.entries(fields).map(([field, value]) => {

                            const FieldComponent = getComponentFromField(field, value)
                            const LabelComponent = getLabelComponentFromField(field)

                            return <li key={ field }>
                                <LabelComponent field={field} value={value} />
                                <FieldComponent field={field} value={value} />
                            </li>
                        })
                    }
                </ul>
            </div>
        )
    }
}

export default withTranslation()(FieldList)
